var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727831",
    fillRule: "nonzero",
    stroke: "#727831",
    strokeWidth: 0.2,
    d: "M29.56 36.628a2.515 2.515 0 0 1-2.409 1.844c-1.319 0-2.416-1.042-2.497-2.372h-.006v-2.089c2.862-1.105 5.4-8.524 5.4-11.44 0-2.932-1.75-5.535-4.237-6.42V9.9c0-1.027-.826-1.861-1.842-1.861a1.853 1.853 0 0 0-1.842 1.86v6.231c-2.519.866-4.291 3.477-4.291 6.44 0 2.896 2.502 10.23 5.339 11.415v2.442c-.228 1.174-1.258 2.044-2.454 2.044a2.488 2.488 0 0 1-2.33-1.602l-1.37.545a3.955 3.955 0 0 0 3.7 2.545 3.976 3.976 0 0 0 3.212-1.661 3.964 3.964 0 0 0 3.218 1.661c1.774 0 3.348-1.204 3.828-2.929l-1.418-.403zM19.31 22.571v-.02h9.264v.02c0 .333-.03.699-.084 1.086h-9.095a7.881 7.881 0 0 1-.085-1.086zm3.716-5.151l.575-.131V9.9c0-.201.169-.372.368-.372.2 0 .369.17.369.372v7.394l.566.136c1.678.403 2.99 1.835 3.47 3.633H19.51c.483-1.818 1.813-3.255 3.516-3.643zm-3.329 7.725h8.49c-.875 3.413-3.024 7.52-4.245 7.52-1.22 0-3.37-4.107-4.245-7.52z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishing);
export default __webpack_public_path__ + "static/media/fishing.15e46e574d3668bdab92929b19ae5e78.svg";
export { ForwardRef as ReactComponent };